/**
 * 捐赠钱包相关路由配置
 */
const walletRoutes = [
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/views/my/WalletView.vue'),
    meta: {
      title: '捐赠钱包',
      requireAuth: true,
      hideNav: true
    }
  }
]

export default walletRoutes
